import {Component, Injector} from "@angular/core";
import {MembershipTypeSearchModel} from "../membership-type-search.model";
import {MembershipTypeSearchPageComponent} from "../membership-type-search-page/membership-type-search-page.component";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-membership-type-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(MembershipTypeSearchModel),
        registerSearchControl(MembershipTypeMultiSelectSearchControlComponent)
    ]
})
export class MembershipTypeMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<MembershipTypeSearchModel> {
    constructor(model: MembershipTypeSearchModel, injector: Injector) {
        super(model, injector, "membershipTypeId", "name");
        this.extendedSearchComponent = MembershipTypeSearchPageComponent;
    }
}
